module.exports = __webpack_public_path__ + "img/bao.bfb3a90c.png";